import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function TourAlbum2019() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            本社見学2018年
          </Typography>
          <Box my={4}>
            <Paper>
              <Grid className="p-3" spacing={4} container direction="row" justify="left">
                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181218_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立江陽小学校５年生のみなさん(2018/12/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181214_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立向小学校５年生のみなさん(2018/12/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181214_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立南部小学校５年生のみなさん(2018/12/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181211_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立福田小学校５年生のみなさん(2018/12/11)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181127_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立東公民館・会茶見くらぶのみなさん(2018/11/27)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181121_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          七戸町立城南小学校５年生のみなさん(2018/11/21)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181120_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立長者小学校５年生のみなさん(2018/11/20)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181120_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立長者小学校５年生のみなさん(2018/11/20)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181109_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          六戸町・夢生学習塾のみなさん(2018/11/09)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181109_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町二川目町内会いきいきサロンのみなさん(2018/11/09)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181101_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立城下小学校２年生のみなさん(2018/11/01)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181031_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市鴎盟大学２６期会有志のみなさん(2018/10/31)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181030_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          久慈市立夏井小学校５年生のみなさん(2018/10/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181030_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          九戸村立山根小学校５年生のみなさん(2018/10/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181030_03.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          九戸村立戸田小学校５年生のみなさん(2018/10/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181030_04.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          新郷村立西越小学校５年生のみなさん(2018/10/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181029_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市教育委員会みなみ大学のみなさん(2018/10/29)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181026_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          五戸町立五戸小学校５年生のみなさん(2018/10/26)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181026_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          五戸町立五戸小学校５年生のみなさん(2018/10/26)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181025_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸第二養護学校小学部６年生のみなさん(2018/10/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181024_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          盛岡市立松園中学校２年生のみなさん(2018/10/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181018_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          階上町立階上小学校３～６年生のみなさん(2018/10/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181012_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県印刷工業組合八戸支部三八地区刷親会のみなさん(2018/10/12)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181010_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸東高校１、２年生のみなさん(2018/10/10)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181010_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸東高校１、２年生のみなさん(2018/10/10)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181005_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立南浜中学校１～３年生のみなさん(2018/10/05)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181005_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立南浜中学校１～３年生のみなさん(2018/10/05)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img181005_03.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市立南浜中学校１～３年生のみなさん(2018/10/05)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180921_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸第一養護学校小学部５年　古田光君と苫米地晃洋教諭(2018/09/21)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180920_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          三戸町立三戸小学校５年生のみなさん(2018/09/20)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180920_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          三戸町立三戸小学校５年生のみなさん(2018/09/20)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180918_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          二戸市立金田一小学校５年生のみなさん(2018/09/18)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180824_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          二戸市・安養寺婦人会のみなさん(2018/08/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180817_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          東京都目黒区　岡田聖子さん、聖菜さん、聖音さん(2018/08/17)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180726_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市　工藤亮さん、福山遊良さん(2018/07/26)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180725_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          デーリー東北読者クラブ「DTくらぶ」夏休み親子印刷工場見学会参加者のみなさん（１）(2018/07/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180725_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          デーリー東北読者クラブ「DTくらぶ」夏休み親子印刷工場見学会参加者のみなさん（２）(2018/07/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180724_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          マリエント「ちきゅう」たんけんクラブのみなさん（１）(2018/07/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180724_02.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          マリエント「ちきゅう」たんけんクラブのみなさん（２）(2018/07/24)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180706_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          階上町立大蛇小学校５年生のみなさん(2018/07/06)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180705_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          山形県最上町議会広報編集委員会のみなさん(2018/07/05)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180619_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ町・向山町内会いきいきサロンのみなさん(2018/06/19)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180614_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田市老人クラブ連合会吾郷熟年クラブのみなさん(2018/06/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180612_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          八戸市・千葉幼稚園広報委員会のみなさん(2018/06/12)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180517_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          七戸町民生委員児童委員協議会のみなさん(2018/05/17)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180514_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          ＮＰＯ法人八戸ノルディック・ウォーク倶楽部のみなさん(2018/05/14)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180322_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          洋野町老人クラブ連合会のみなさん(2018/03/22)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180316_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          洋野町・戸類家やまびこ会のみなさん(2018/03/16)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180302_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸商業高校国際経済科２年生のみなさん(2018/03/02)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180208_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          青森県立八戸高等支援学校普通科３年１組のみなさん(2018/02/08)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180206_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          おいらせ農協にんにく部会折茂支部のみなさん(2018/02/06)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180130_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          南部町立名久井小学校５年生のみなさん(2018/01/30)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} className="font-weight-bold">
                  <Card className={classes.card}>
                    <CardActionArea>
                      <CardMedia
                       component="img"
                       maxWidth="500"
                       maxHeight="350"
                       image="/images/kengaku/2018/k_img180125_01.jpg"
                      />
                      <CardContent>
                        <Typography gutterBottom variant="subtitle1" component="h2">
                          十和田おいらせ農協女性部おいらせ町支部のみなさん(2018/01/25)
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>

              </Grid>
            </Paper>
          </Box>
        </Box>
      </div>
    </div>
  );
}

export default TourAlbum2019;
